var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.00006L11.5 1.00006L17.5 7.00006ZM17.5 7.00006L11.5 13.0001L17.5 7.00006ZM17.5 7.00006L7 7.00006L17.5 7.00006ZM1.5 7.00006L4 7.00006L1.5 7.00006Z",
    fill: "url(#paint0_linear_42_1054)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.00006L11.5 1.00006M17.5 7.00006L11.5 13.0001M17.5 7.00006L7 7.00006M1.5 7.00006L4 7.00006",
    stroke: "url(#paint1_linear_42_1054)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1054",
    x1: 17.0805,
    y1: 1.00006,
    x2: 15.5897,
    y2: 15.1932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1672A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722356,
    stopColor: "#0AA6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97DDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_1054",
    x1: 17.0805,
    y1: 1.00006,
    x2: 15.5897,
    y2: 15.1932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1672A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722356,
    stopColor: "#0AA6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97DDED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.7f639305fab07702b7dc5ebc3a82cb92.svg";
export { ForwardRef as ReactComponent };